import React from 'react';
import { FaComments, FaFileAlt, FaLaptop, FaUsers } from 'react-icons/fa';
import {
  ManualOverview,
  OverviewContent,
  OverviewTitle,
  OverviewText,
  OverviewActions,
  ManualPanel,
  PanelHeader,
  //   PanelEyebrow,
  ManualStatusList,
  ManualStatusItem,
  StatusIcon,
} from './Overview.styles';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import SecondaryButton from '../../../Components/Buttons/SecondaryButton/SecondaryButton.component';

const Overview = () => {
  const navigate = useNavigate();
  return (
    <ManualOverview>
      <OverviewContent>
        {/* <p className="eyebrowHeader">Safety Documentation</p> */}

        <OverviewTitle>
          Build a Safety Manual That Fits Your Workplace
        </OverviewTitle>

        <OverviewText>
          A workplace safety manual should reflect how your organization
          actually operates. Yoda Safety Services can work with your company to
          develop safety documentation tailored to your workplace, procedures,
          and safety needs.
        </OverviewText>

        <OverviewText>
          Once your manual is ready, it can also be made available digitally
          through your company account, giving employees a convenient place to
          access important safety information.
        </OverviewText>

        <OverviewActions>
          <PrimaryButton
            functionName={() => navigate('/contact-us')}
            span="Ask About a Safety Manual"
          />
          <SecondaryButton
            functionName={() => navigate('/company-training')}
            span=" Explore Company Accounts"
          />
        </OverviewActions>
      </OverviewContent>

      <ManualPanel>
        <PanelHeader>
          <div>
            {/* <PanelEyebrow>Workplace Manuals</PanelEyebrow> */}
            <h3>From Development to Employee Access</h3>
          </div>
        </PanelHeader>

        <ManualStatusList>
          <ManualStatusItem>
            <StatusIcon>
              <FaComments />
            </StatusIcon>

            <div>
              <strong>Understand Your Needs</strong>
              <span>
                Start with your workplace, operations, and safety requirements.
              </span>
            </div>
          </ManualStatusItem>

          <ManualStatusItem>
            <StatusIcon>
              <FaFileAlt />
            </StatusIcon>

            <div>
              <strong>Build the Manual</strong>
              <span>
                Develop safety documentation designed around your organization.
              </span>
            </div>
          </ManualStatusItem>

          <ManualStatusItem>
            <StatusIcon>
              <FaLaptop />
            </StatusIcon>

            <div>
              <strong>Make It Available Online</strong>
              <span>
                Add the manual to your company account for digital access.
              </span>
            </div>
          </ManualStatusItem>

          <ManualStatusItem>
            <StatusIcon>
              <FaUsers />
            </StatusIcon>

            <div>
              <strong>Give Your Team Access</strong>
              <span>
                Keep important workplace safety information easier to reach.
              </span>
            </div>
          </ManualStatusItem>
        </ManualStatusList>
      </ManualPanel>
    </ManualOverview>
  );
};

export default Overview;
